mutation RestoreForm($id: ID!) {
    formRestore(input: {id: $id}) {
        form {
            id
        }
    }
}
